module.exports = Promise.resolve(parcelRequire("hJ5SK"))